import { IOnInit } from "angular";
import { FeesRepo } from "@services/fees.repo";
import * as _ from "lodash";
import { extractErrorMessage } from "@common/utils/errorUtils";

class EditDebitAccountDialogController implements IOnInit {
  public account: any;
  public clientCashAccounts: Array<any>;
  public clientCashAccountsGroupedByCurrency: Array<any>;
  public debitAccountForm: ng.IFormController;
  
  // Editable fields
  public accountId: number;

  /** @ngInject */
  constructor(
    private $mdDialog: angular.material.IDialogService,
    private feesRepo: FeesRepo,
    private notifyjs: any
  ) {}

  $onInit() {
    // Initialize editable fields from the account data
    if (this.account) {
      this.accountId = this.account.accountId;
      // If accountId exists, populate currency and accountNumber
      if (this.accountId && this.clientCashAccounts) {
        this.selectCashAccountCurrency();
      }
    }
  }

  cancel = () => {
    this.$mdDialog.cancel();
  };

  selectCashAccountCurrency = () => {
    let selectedAccount = this.clientCashAccounts.filter((cashAccount: any) => {
      // Use strict equality to avoid type coercion issues. Normalize both sides to strings
      // so comparisons work correctly whether IDs are numbers or strings.
      return String(cashAccount.id) === String(this.accountId);
    });
    if (selectedAccount && selectedAccount.length > 0) {
      this.account.currency = _.first(selectedAccount).currency;
      this.account.accountNumber = _.first(selectedAccount).accountNumber;
      this.account.accountId = this.accountId;
    }
  };

  save = () => {
    if (!this.accountId) {
      this.notifyjs("Please select an account", "warning");
      return;
    }

    // Update account with selected account details
    this.selectCashAccountCurrency();

    // Create the update payload
    const accountDetails = {
      ...this.account,
      accountId: this.accountId
    };

    this.feesRepo
      .addEditPortfolioFeeCashAccount(accountDetails)
      .then((res) => {
        this.$mdDialog.hide(accountDetails);
      })
      .catch((err) => {
        this.notifyjs("Failed to update debit account: " + extractErrorMessage(err));
      });
  };
}

export const editDebitAccountDialog: angular.IComponentOptions = {
  template: require("./editDebitAccount.dialog.html"),
  controller: EditDebitAccountDialogController,
  bindings: {
    account: "<",
    clientCashAccounts: "<",
    clientCashAccountsGroupedByCurrency: "<"
  }
};




// WEBPACK FOOTER //
// ./src/app/fees/debitAccounts/editDebitAccount.dialog.ts